(() => {
  function initializeDolobitesConsentV3() {
    const booking = document.querySelector('.db-booking');

    if (
      !booking ||
      booking.dataset.consentV3Initialized === 'true'
    ) {
      return;
    }

    const termsCheckbox = booking.querySelector(
      '#db-accept-terms'
    );

    const depositCheckbox = booking.querySelector(
      '#db-accept-deposit'
    );

    const consentContainer = booking.querySelector(
      '.db-booking__consents'
    );

    const consentMessage = booking.querySelector(
      '#db-consent-message'
    );

    const checkoutButton = booking.querySelector(
      '.db-booking__checkout-button'
    );

    if (
      !termsCheckbox ||
      !depositCheckbox ||
      !checkoutButton
    ) {
      return;
    }

    booking.dataset.consentV3Initialized = 'true';

    const updateConsent = () => {
      const consent = {
        termsAccepted: termsCheckbox.checked,
        depositAccepted: depositCheckbox.checked
      };

      const allAccepted =
        consent.termsAccepted &&
        consent.depositAccepted;

      window.DOLOBITES_V3_CONSENT = consent;

      consentContainer?.classList.toggle(
        'is-complete',
        allAccepted
      );

      if (consentMessage) {
        consentMessage.textContent = allAccepted
          ? 'All conditions accepted.'
          : 'Please accept both conditions to continue.';
      }

      checkoutButton.disabled =
        !window.DOLOBITES_V3_CUSTOMER?.isValid ||
        !allAccepted;

      document.dispatchEvent(
        new CustomEvent('dolobites:consent-change', {
          detail: consent
        })
      );
    };

    termsCheckbox.addEventListener(
      'change',
      updateConsent
    );

    depositCheckbox.addEventListener(
      'change',
      updateConsent
    );

    document.addEventListener(
      'dolobites:customer-change',
      updateConsent
    );

    updateConsent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeDolobitesConsentV3
    );
  } else {
    initializeDolobitesConsentV3();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeDolobitesConsentV3
  );
})();